export default {
    "bloodlust": {
        "name": "Bloodlust",
        "description": () => {
            return "+1 for each damaged unit."
        }
    },
    "engage": {
        "name": "Engage",
        "description": () => {
            return "Doubled if target is at full health."
        }
    },
    "mana": {
        "name": "Mana",
        "description": () => {
            return "+1 for each point of mana you've accrued."
        }
    },
    "unused rolls": {
        "name": "Unused Rolls",
        "description": () => {
            return "+1 for your remaining unused rolls."
        }
    },
    "hurt": {
        "name": "Hurt",
        "description": () => {
            return "You also take damage."
        }
    },
    "rampage": {
        "name": "Rampage",
        "description": () => {
            return "If you fell an enemy, you can move and attack again."
        }
    },
    "wound": {
        "name": "Wound",
        "description": () => {
            return "When wounded, you take additional damage with each attack. +1 damage for each wound."
        },
    },
    "poison": {
        "name": "Poison",
        "description": () => {
            return "When poisoned, you take damage at the end of your turn. +1 damage for each poison."
        },
    },
    "counter": {
        "name": "Counter",
        "description": () => {
            return "x2 during counter-attacks"
        },
    },
    "defend": {
        "name": "Defend",
        "description": () => {
            // return "Grants the target temporary health until your next turn."
            return "Reduces all incoming damage."
        }
    }
}
